import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../../../axios-backend";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const ProductVideo = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    // All hooks must be called before any conditional returns
    const [videos, setVideos] = useState('');

    // Get state values safely
    const state = location.state || {};
    const { type, gender } = state;

    const getData = useCallback(() => {
        if (type && gender !== undefined && gender !== null) {
            // Convert gender to string to ensure consistency
            const genderParam = String(gender);

            axios.get('/get-pro-related-video', {
                params: {
                    id: type,
                    gender: genderParam
                }
            }).then((data) => {
                if (data.data.video) {
                    setVideos(data.data.video)
                }
            }).catch((error) => {
                console.error('ProductVideo - API error:', error);
            })
        }
    }, [type, gender])

    useEffect(() => {
        // Redirect if no state
        if (!location.state) {
            navigate('/');
            return;
        }

        getData();
    }, [getData, location.state, navigate]);

    // Early return if no state
    if (!location.state) {
        return null;
    }

    return (
        <>
            <BackButton />
            <Video url={`${videos}`} maxHeight="80%" />
        </>
    );
}

export default ProductVideo;

